import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconBeachAccess = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconBeachAccess",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M758-148 560-346q-11-11-11-28t11-28 28-11 28 11l198 198q11 11 11 28t-11 28-28 11-28-11m-453-65q-28 28-65 27t-58-33q-60-93-63-201t49-205q3 34 17 77t39 89 58 97 75 97zm107-107q-48-48-84-104t-56-110-23-96 18-65q21-22 65-20t97 23 110 57 104 84zm330-459q31 20 33 57t-26 65l-51 51q-47-41-96-74t-96-58-89-39-77-18q95-49 203-45t199 61"
  })
}));
IconBeachAccess.displayName = 'IconBeachAccess';